<template>
  <div v-if="urlYoutube">
    <div id="containerYoutube">
      <h2 class="headerCard">{{ titleLabel }}</h2>
      <div>
        <iframe
          class="youtubeVideo"
          :src="urlYoutube"
          frameborder="0"
          allowfullscreen=""
        ></iframe>
      </div>
    </div>
  </div>
  <div v-else>
    <div id="container">
      <h2 class="headerCard">{{ titleLabel }}</h2>
      <div class="img-wrapper">
        <img
          :src="require(`@/assets/logos/${imageLogo}`)"
          :alt="imageLogo"
          v-bind:class="[subtitleLabel ? '' : 'double-height']"
        />
      </div>
      <p class="detail" v-if="subtitleLabel">{{ subtitleLabel }}</p>
      
      <div class="button-wrapper" @click="navigateToDetail(urlDoc)">
        <div class="layer"></div>
        <button class="main-button fa fa-info">
          <div class="ripple"></div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",

  props: [
    "titleLabel",
    "subtitleLabel",
    "imageLogo",
    "urlDoc",
    "urlYoutube",
    "labelImageToShow",
    "numberPhotos",
  ],

  methods: {
    navigateToDetail(url) {
      if (url) {
        var link = document.createElement("a");
        // If you don't know the name or want to use
        // the webserver default set name = ''
        link.setAttribute('download', '');
        link.href = url;

        document.body.appendChild(link);

        link.click();
        link.remove();

        return;
        // return window.open(hasLink, "_blank");
      }

      return this.$router.push({
        path: `/carousel-images/${this.numberPhotos}/${this.labelImageToShow}`,
      });
    },
  },
};
</script>

<style>
button:focus {
  outline: none;
}

button:hover {
  opacity: 0.8;
}

.fa {
  font-size: 20px;
}

.fa-info {
  color: white;
}

.youtubeVideo {
  height: 200px;
  width: 100%;
}

#container {
  width: 330px;
  height: 530px;
  max-width: 330px;
  background: white;
  position: relative;
  left: 50%;
  margin-bottom: 100px;
  overflow: hidden;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);
  transform: translate3d(-50%, -50%, 0);
}

#containerYoutube {
  width: 330px;
  height: 300px;
  max-width: 400px;
  background: white;
  position: relative;
  left: 50%;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);
  transform: translate3d(-50%, -50%, 0);
}

.double-height {
  height: 350px !important;
}

h2.headerCard {
  padding: 20px;
  color: white;
  background: #3e4fb2;
  text-align: center;
  font-size: 18px;
}

.detail {
  color: #777;
  padding: 20px;
}

.img-wrapper {
  padding: 0;
  position: relative;
}

.img-wrapper:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
}

.img-wrapper img {
  width: 100%;
  height: 240px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
  margin: 0;
  display: block;
  position: relative;
}

.button-wrapper {
  width: 50px;
  height: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  right: 20px;
  bottom: 20px;
}

button {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
  z-index: 9;
  position: relative;
}

.main-button {
  background: #ff2670;
  -webkit-align-self: flex-end;
  -ms-flex-item-align: end;
  align-self: flex-end;
}

.ripple {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  border-radius: 50%;
  z-index: -9;
  background: transparent;
  border: 1px solid #ff2670;
  -webkit-transform: scale(0.5);
  -ms-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transition: 0.3s all ease;
  transition: 0.3s all ease;
  opacity: 1;
}

.rippling {
  -webkit-animation: 0.3s rippling 1;
  animation: 0.3s rippling 1;
  -moz-animation: 0.3s rippling 1;
}

@-webkit-keyframes rippling {
  25% {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(2);
    transform: scale(2);
    opacity: 0;
  }
}

@-moz-keyframes rippling {
  25% {
    -moz-transform: scale(1.5);
    transform: scale(1.5);
    opacity: 1;
  }

  100% {
    -moz-transform: scale(2);
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes rippling {
  25% {
    transform: scale(1.5);
    opacity: 1;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.layer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
  background: #ff2670;
  border-radius: 50%;
  z-index: -99;
  pointer-events: none;
}

.button-wrapper.clicked {
  -webkit-transform: rotate(90deg) translateY(-96px);
  -ms-transform: rotate(90deg) translateY(-96px);
  transform: rotate(90deg) translateY(-96px);
  right: 0;
  bottom: 0;
  -webkit-transition: 0.3s all ease 0.6s;
  transition: 0.3s all ease 0.6s;
}

.button-wrapper.clicked .main-button {
  opacity: 0;
  -webkit-transition: 0.3s all ease 0.3s;
  transition: 0.3s all ease 0.3s;
}

.button-wrapper.clicked .layer {
  -webkit-transform: scale(100);
  -ms-transform: scale(100);
  transform: scale(100);
  -webkit-transition: 2.25s all ease 0.9s;
  transition: 2.25s all ease 0.9s;
}

.layered-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  opacity: 0;
}

.layered-content.active {
  opacity: 1;
}

.layered-content .content img {
  width: 80px;
  -webkit-shape-outside: 80px;
  shape-outside: 80px;
  border-radius: 50%;
  display: block;
  margin: 0 auto 15px;
  padding: 10px;
  box-sizing: border-box;
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
  -webkit-transition: 0.3s all ease;
  transition: 0.3s all ease;
}

.layered-content.active .content img {
  opacity: 1;
  top: 0;
  -webkit-transition: 0.5s all ease 0.5s;
  transition: 0.5s all ease 0.5s;
}

.layered-content.active .content p {
  opacity: 1;
  top: 0;
  -webkit-transition: 0.5s all ease 1s;
  transition: 0.5s all ease 1s;
}

@media (max-width: 1000px) {
  #container {
    height: 470px;
    margin-bottom: 15px;
  }
  #containerYoutube {
    width: 260px;
    margin-bottom: 15px;
  }
  .img-wrapper img {
    height: 200px;
  }
}

@media (max-width: 800px) {
  #container {
    height: 470px;
    margin-bottom: 15px;
  }
  #containerYoutube {
    width: 170px;
    margin-bottom: 15px;
  }
  .img-wrapper img {
    height: 200px;
  }
}

@media (max-width: 450px) {
  #container {
    height: 530px;
    width: 280px;
    margin-bottom: 15px;
  }
  #containerYoutube {
    height: 260px;
    width: 355px;
    margin-bottom: 15px;
  }
  .img-wrapper img {
    height: 235px;
  }
}

@media (max-width: 320px) {
  #container {
    height: 530px;
    width: 20px;
    margin-bottom: 15px;
  }
  #containerYoutube {
    height: 260px;
    width: 250px;
    margin-bottom: 15px;
  }
  .img-wrapper img {
    height: 235px;
  }
}
</style>
